<template>
  <general-reports-table
    :config="config"
    for-admin
  />
</template>

<script>
import GeneralReportsTable from '@/views/owner-fb/reply/GeneralReportsTable'
import ReportsTableConfig from './config/reports-table-config'

export default {
  components: {
    GeneralReportsTable,
  },
  data() {
    return {
      config: ReportsTableConfig,
    }
  },
}
</script>
